import UbahRAP from './UbahRAP';

export default UbahRAP;
